"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    justifyContent: "space-between",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row"
    }
  },
  shopButton: {
    display: "flex",
    [theme.breakpoints.up("sm")]: {
      display: "flex"
    }
  },
  isLoading: {
    "& svg": {
      height: 24,
      marginRight: theme.spacing(1),
      width: 24
    }
  }
}));
var _default = exports.default = styles;